const ITEMS = [
  "Emorroidi",
  "Ragadi anali",
  "Fistole anali",
  "Cisti sacrococcigea",
  "Comfort del paziente",
  "Recupero rapido",
  "Senza tabù",
  "30+ anni di esperienza",
];

export default function Marquee() {
  return (
    <section className="marquee-wrap relative border-y hairline bg-card/40 py-5 overflow-hidden">
      <div className="animate-marquee flex w-max">
        {ITEMS.map((t, i) => (
          <span
            key={i}
            aria-hidden={i >= ITEMS.length}
            className="flex items-center gap-10 pr-10 text-[13px] uppercase tracking-[0.32em] text-silver whitespace-nowrap"
          >
            {t}
            <span className="inline-block w-2 h-2 rotate-45 bg-gold/70" />
          </span>
        ))}
      </div>
    </section>
  );
}
